module.exports = __webpack_public_path__ + "site/img/77.92ad9eba.jpg";